import Grid from '@material-ui/core/Grid';

function Item({ ...others }) {
  return <Grid item {...others} />;
}

Item.propTypes = {
  ...Grid.propTypes,
};

export default Item;
